const NAME_SPACE = 'NewsOverviewPage';

export { NAME_SPACE };
